import { baseApi } from './baseApi'
import { OutgoingDocumentsListResponse, OutgoingDocumentsStatus } from 'store/types'

export const outgoingDocumentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOutgoingDocuments: builder.query<
      OutgoingDocumentsListResponse,
      { page: number; size: number; status?: OutgoingDocumentsStatus }
    >({
      query: ({ page, size, status }) => ({
        url: `/lab/orders/outgoing-documents`,
        params: { page, size, ...(status ? { status } : {}) },
      }),
      providesTags: ['OrderList'],
    }),
  }),
})

export const { useGetOutgoingDocumentsQuery } = outgoingDocumentsApi
